// Sygnał po skanie. Przy ladzie wzrok jest na sprzęcie i kliencie, nie na ekranie — czytnik
// sklepowy piszczy z tego samego powodu. Krótki ton = przyjęte, dwa niskie = coś nie tak.

let audio = null;

function ton(czestotliwosc, poczatek, dlugosc) {
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.frequency.value = czestotliwosc;
  gain.gain.setValueAtTime(0.08, audio.currentTime + poczatek);
  gain.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + poczatek + dlugosc);
  osc.connect(gain).connect(audio.destination);
  osc.start(audio.currentTime + poczatek);
  osc.stop(audio.currentTime + poczatek + dlugosc + 0.02);
}

/** tone: 'ok' | 'warn' | 'error'. Nigdy nie rzuca — brak dźwięku to nie awaria skanu. */
export function signalScan(tone = 'ok') {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(tone === 'ok' ? 60 : [90, 60, 90]);
    }
  } catch (_) { /* wibracja niedostępna */ }
  try {
    const Ctx = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
    if (!Ctx) return;
    if (!audio) audio = new Ctx();
    if (audio.state === 'suspended') audio.resume();
    if (tone === 'ok') ton(1320, 0, 0.09);
    else { ton(330, 0, 0.12); ton(330, 0.16, 0.12); }
  } catch (_) { /* przeglądarka bez dźwięku albo zablokowany autoplay */ }
}
